module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-152x152-03202cf6e07c3d941cdc35c36ce3d1a6.png";